import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getVisibleItems } from 'resolvers/getVisibleEntities';

/*************************************************************/

/**
 * @type {class}
 * @desc OffCallControlWidget defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { OffCallControlWidgetService } from 'services/offCallControlWidget';
 *
 * // create service instance and send/cancel request
 * const offCallControlWidgetService = new OffCallControlWidgetService();
 * const result = await offCallControlWidgetService.fetchData( '<user-id>' ); // fetch data
 * offCallControlWidgetService.cancel(); // cancel an active request
 */
export class OffCallControlWidgetService extends HttpService {

    // fetch call control widget data
    async fetchComponentData( { url = {}, data = {} } = {} ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data
            } );

            // extract component data
            const visibility = get( response, 'body.component.visibility', {} );
            const callDispositionWidgets = get( response, 'body.component.structure.widgets', [] );
            const navActions = get( response, 'body.component.structure.navActions', [] );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    callDispositionWidgets: getVisibleItems( callDispositionWidgets, visibility ),
                    navActions: getVisibleItems( navActions, visibility )
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
